import store from 'store'

class Translate {
  constructor () {
    this.state = store.getState().siteReducer
    store.subscribe(() => {
      this.state = store.getState().siteReducer
    })
  }
  translate (obj) {
    return obj[this.state.language]
  }
}
export default function (obj) {
  var t = new Translate()
  return t.translate(obj)
}



// WEBPACK FOOTER //
// ./src/helpers/translate.js